import styled from '@emotion/styled'
import { withClass } from 'common/emotion'

import { calcRem } from 'component-library/__styling/style-functions'
import { metrics, colors } from 'component-library/__styling/settings'

import { CardMedia } from 'component-library/cards/CardMedia/CardMedia'
import { CSSObject } from '@emotion/css'
export interface StyledCardProps {
    isSponsored: boolean | null
}

export const styledTimestampClassName = 'Card-Timestamp'

const cardMediaStyles: CSSObject = {
    flex: `1 3 ${calcRem(106)}`,
    marginRight: calcRem(metrics.perthnow.margins.sm),
    marginBottom: calcRem(metrics.perthnow.cards.spacing),
    maxWidth: calcRem(86),
}

export const StyledMedia = styled(CardMedia)({
    ...cardMediaStyles,
})

export const StyledTimestampBlock = withClass(styledTimestampClassName)(
    styled('div')({
        ...cardMediaStyles,
        overflow: 'hidden',
        width: '100%',
        backfaceVisibility: 'hidden',
        position: 'relative',
        color: colors.black,
        backgroundColor: colors.perthnow.greyGlass,
        textAlign: 'center',
        height: calcRem(65),
        alignItems: 'center',
        display: 'flex',
    })
)

export const StyledTime = withClass(styledTimestampClassName)(
    styled('time')(
        {
            fontSize: calcRem(14),
            fontWeight: 700,
            textAlign: 'center',
            width: '100%',
        },
        ({ theme }) => ({
            fontFamily: theme.fonts.sansSerifCond,
        })
    )
)
